import { DateChangeProps, IFieldType, IFormFields } from "shared/types";
import { copy } from "shared/assets";
import { DateFormat, TimeFormat } from "shared/utils";
import { IScheduleBlockEntry } from "Bands/types";

const { errors } = copy;
const entryProperties = copy.scheduleBlock.addEntry.properties;
const entryMessages = copy.scheduleBlock.addEntry.messages;

export const getFormFields = ({
  excludeUsers,
  handleStartDateChange,
  handleEndDateChange,
  isStartBeforeEnd,
  timeFormat,
  dateFormat,
  isEdit,
  showEditEntryModal,
}: {
  excludeUsers?: string[] | undefined;
  handleStartDateChange: (date: DateChangeProps) => void;
  handleEndDateChange: (date: DateChangeProps) => void;
  isStartBeforeEnd: boolean;
  timeFormat?: TimeFormat;
  dateFormat?: DateFormat;
  isEdit?: boolean;
  showEditEntryModal?: IScheduleBlockEntry | null;
}): IFormFields => {
  return [
    {
      name: "title",
      label: entryProperties.title.title,
      type: IFieldType.text,
      validation: {
        required: errors.required,
      },
      style: {
        gridColumn: "1/4",
        mobile: { gridColumn: "span 1" },
      },
      tabIndex: (!!showEditEntryModal && isEdit) || (!showEditEntryModal && !isEdit) ? 1 : -1,
    },
    {
      name: "startDate",
      label: entryProperties.startDate.title,
      type: IFieldType.datePicker,
      validation: {
        required: errors.required,
        validate: () => isStartBeforeEnd || entryMessages.startBeforeEnd,
      },
      onChange: (value: string) => handleStartDateChange({ date: value }),
      dateFormat,
      tabIndex: (!!showEditEntryModal && isEdit) || (!showEditEntryModal && !isEdit) ? 2 : -1,
    },
    {
      name: "startTime",
      label: entryProperties.startTime.title,
      type: IFieldType.simpleTime,
      validation: {
        required: errors.required,
        validate: () => isStartBeforeEnd,
      },
      onChange: (value: string) => handleStartDateChange({ time: value }),
      timeFormat,
      tabIndex: (!!showEditEntryModal && isEdit) || (!showEditEntryModal && !isEdit) ? 3 : -1,
    },
    {
      name: "startTimezone",
      label: entryProperties.startTimezone.title,
      type: IFieldType.timezone,
      validation: {
        required: errors.required,
        validate: () => isStartBeforeEnd,
      },
      onChange: (data?: { value: string }) =>
        data?.value && handleStartDateChange({ timeZone: data.value }),
    },
    {
      name: "endDate",
      label: entryProperties.endDate.title,
      type: IFieldType.datePicker,
      validation: {
        required: errors.required,
      },
      onChange: (value: string) => handleEndDateChange({ date: value }),
      dateFormat,
      tabIndex: (!!showEditEntryModal && isEdit) || (!showEditEntryModal && !isEdit) ? 4 : -1,
    },
    {
      name: "endTime",
      label: entryProperties.endTime.title,
      type: IFieldType.simpleTime,
      validation: {
        required: errors.required,
      },
      onChange: (value: string) => handleEndDateChange({ time: value }),
      timeFormat,
      tabIndex: (!!showEditEntryModal && isEdit) || (!showEditEntryModal && !isEdit) ? 5 : -1,
    },
    {
      name: "endTimezone",
      label: entryProperties.endTimezone.title,
      type: IFieldType.timezone,
      validation: {
        required: errors.required,
      },
      onChange: (data?: { value: string }) =>
        data?.value && handleEndDateChange({ timeZone: data.value }),
    },
    {
      name: "users",
      label: entryProperties.users.title,
      note: entryProperties.users.note,
      type: IFieldType.peoplePicker,
      style: {
        gridColumn: "1/4",
        mobile: { gridColumn: "span 1" },
      },
      settings: {
        excludeOptions: excludeUsers,
        includeInvitedUsers: true,
      },
      tabIndex: (!!showEditEntryModal && isEdit) || (!showEditEntryModal && !isEdit) ? 6 : -1,
    },
    {
      name: "description",
      label: entryProperties.description.title,
      type: IFieldType.textarea,
      style: {
        gridColumn: "1/4",
        mobile: { gridColumn: "span 1" },
      },
      tabIndex: (!!showEditEntryModal && isEdit) || (!showEditEntryModal && !isEdit) ? 7 : -1,
    },
  ];
};
